/* eslint-disable indent */
import React, { FC } from 'react';
import { View, Animated, Text } from 'react-native';
import LinearGradient from 'react-native-linear-gradient';
import i18n from 'i18n-js';

import { Element, notchTop, scale } from '@components/frame';

import { font } from '@styles/fonts';

import { isPhone, isWeb, isIOS } from '@helpers';

import ThumbnailHeaderMobileIcons from './components/ThumbnailHeaderMobileIcons';
import ThumbnailHeaderWebTabletIcons from './components/ThumbnailHeaderWebTabletIcons';
import { TAG_NAMING } from '@components/imageHandling/common';
import { ThumbnailScrollProps } from '@v2/components/imageHandling/components/Thumbnail/components/ThumbnailScroll/types.d';

interface ThumbnailHeaderProps extends Pick<ThumbnailScrollProps, 'C' | 'fadeAnim' | 'headers' | 'setMode'> {
  scrolled: boolean;
  onBackButtonPress?: () => void;
}

const ThumbnailHeader: FC<ThumbnailHeaderProps> = (props) => {
  const { C, fadeAnim, headers, scrolled, setMode, onBackButtonPress } = props;
  const startFrom = 10;

  const offset = isIOS && notchTop === 0 ? 15 : 0;

  return (
    <Element
      key="Header"
      {...{
        config: {
          height: 48,
          position: {
            top: offset,
            left: 0,
            right: 0,
          },
          zIndex: 100,
          backgroundColor: 'transparent',
          animated: true,
        },
      }}
    >
      <Animated.View
        style={{
          width: '100%',
          height: scale(180),
          position: 'absolute',
          top: -scale(offset),
          opacity: fadeAnim.interpolate({
            inputRange: [scale(startFrom) - 0.5, scale(startFrom), scale(startFrom) + 0.5],
            outputRange: [0, 0.8, 1],
            extrapolate: 'clamp',
          }),
        }}
      >
        <LinearGradient
          locations={[0, 0.5885, 1]}
          start={{
            x: 1,
            y: 1,
          }}
          end={{
            x: 1,
            y: 0,
          }}
          colors={['rgba(0, 0, 0, 0)', 'rgba(0, 0, 0, 0.3)', 'rgba(0, 0, 0, 0.8)']}
          style={{ width: '100%', height: '100%' }}
        />
      </Animated.View>
      <View style={{ paddingTop: notchTop }}>
        {isPhone ? <ThumbnailHeaderMobileIcons onBackButtonPress={onBackButtonPress} C={C} scrolled={scrolled} /> : <ThumbnailHeaderWebTabletIcons scrolled={scrolled} setMode={setMode} onBackButtonPress={onBackButtonPress} />}
        <View>
          {Object.values(headers).map(({ data: { key, value, name }, position, height }) => {
            return (
              <Animated.View
                style={{
                  width: '100%',
                  height: scale(60),
                  position: 'absolute',
                  top: scale(7),
                  opacity: fadeAnim.interpolate({
                    inputRange: [
                      0,
                      position - (notchTop + scale(56)),
                      position - (notchTop + scale(55.5)),
                      position + height - scale(170),
                      position + height - scale(135),
                    ],
                    outputRange: [0, 0, 1, 1, 0],
                    extrapolate: 'clamp',
                  }),
                }}
                key={`${key}-${value}`}
              >
                <View style={{ paddingLeft: scale(18), marginBottom: scale(6) }}>
                  <Text style={[{ color: C('Label/Dark/AlwaysLight Primary', !isWeb) }, font.Headline]}>{i18n.t(TAG_NAMING[key])}</Text>
                  <Text style={[{ color: C('Label/Dark/AlwaysLight Secondary', !isWeb) }, font['Subhead 2']]}>{name}</Text>
                </View>
              </Animated.View>
            );
          })}
        </View>
      </View>
    </Element>
  );
};

export default ThumbnailHeader;
